import React, { useCallback, useEffect, useState } from "react";
import ValueLabelDisplay from "../../../../organisms/ValueLabelDisplay";
import ImageAndInitialViewer from "../../../../molecules/ImageAndInitialViewer";
import moment from "moment";
import { deleteData, getData } from "../../../../../services";
import { useCookies } from "react-cookie";

const ViewDetails = ({ data }) => {
  const [cookies] = useCookies(["e_t"]);
  const [apiData, setApiData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);


  const getAllTasks = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await getData({
        endpoint: "Task/getAllTasksOfProject",
        params: {
          project_id: data.id,
        },
        token: cookies.e_t,
      });
      if (res) {
        setApiData(res?.data);
      }
    } catch (error) {
      console.error(error); // Use console.error for errors
    } finally {
      setIsLoading(false);
    }
  }, [cookies.e_t, data.id]);

  useEffect(() => {
    getAllTasks();
  }, [getAllTasks]);

  // Render each task as a card
  const renderTaskCards = () => {
    if (apiData.length === 0) {
      return <div>No tasks found.</div>;
    }

    return apiData.map((task, index) => (
      <div
        key={index}
        style={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          padding: "16px",
          marginBottom: "16px",
          backgroundColor: "#fff",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
           
          }}
        >
          <div style={{ fontSize: "18px", fontWeight: "600" , maxWidth: "300px" }}>{task.name}</div>
          <div style={{ display: "flex", gap: "12px" }}>
            <div
              style={{
                padding: "4px 8px",
                borderRadius: "4px",
                backgroundColor: task.status === "Completed" ? "#e6f4ea" : "#f0f0f0",
                color: task.status === "Completed" ? "#34a853" : "#666",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              {task.status}
            </div>
            <div
              style={{
                padding: "4px 8px",
                borderRadius: "4px",
                backgroundColor:
                  task.priority === "High"
                    ? "#fce8e6"
                    : task.priority === "Medium"
                    ? "#fef7e0"
                    : "#e8f0fe",
                color:
                  task.priority === "High"
                    ? "#d93025"
                    : task.priority === "Medium"
                    ? "#f9ab00"
                    : "#1a73e8",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              {task.priority}
            </div>
          </div>
        </div>

        <div
        style={{
            fontSize: "10px", fontWeight: "600" , marginBottom: "10px",
          }}
        >
                <span>
                    {task.remaining_time &&
                        moment(task.remaining_time).format("DD/MM/YYYY")}
                </span>
        </div>

        {/* Description */}
        <div style={{ fontSize: "14px", color: "#555" }}>{task.description}</div>
      </div>
    ));
  };

  return (
    <>
      {/* Venue Name */}
      {/* <ValueLabelDisplay label={"Venue Name"}>
        {apiData?.[0]?.name}
      </ValueLabelDisplay> */}

      {/* Task Cards */}
      <div style={{ marginTop: "24px" }}>
        {isLoading ? (
          <div>Loading...</div>
        ) : (
          renderTaskCards()
        )}
      </div>
    </>
  );
};

export default ViewDetails;
